import { createContext } from 'react'
import { SubmitHandler, UseFormReturn } from 'react-hook-form'

type Props = UseFormReturn<any> & {
  onSubmit?: SubmitHandler<any>
  formId?: string
}

export const FormContext = createContext<Props>({} as Props)
